import Footer from './footer'
import { connect } from 'react-redux';
import * as snackAction from '../../redux/action/snackbar_action'

const mapDispatchToProps = (dispatch) => {
	return {
		setSnack: (isOn,type,msg) => dispatch(snackAction.setSnackbar(isOn,type,msg))
	}
}

const mapStateToProps=(state)=>{
    return {
            snackState:state.snackbar_reducer
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(Footer)